<template>
  <div class="app-header">
    <div class="app-header-left">
      <img src="@/assets/img/cmb_logo_big.png" alt="boox" />
      <div class="app-header-version">版本 {{ version }}</div>
    </div>
    <div class="app-header-right">
      <div class="app-header-user">
        <el-dropdown
          trigger="click"
          class="header-server-select"
          @command="serverHandleCommand"
        >
          <button class="global-button-style">
            {{ locationInfo.name }}
          </button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="item in serverList"
              :key="item.value"
              :command="item"
              :disabled="item === locationInfo"
              >{{ item.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <img src="@/assets/img/cmb_temp_potrait.png" alt="potrait" />
        <span>{{ userInfo.nickname }}</span>
      </div>
      <div class="header-langSelect">
        <LangSelect class="langSelect-item"></LangSelect>
      </div>
      <i class="column-line-icon"></i>
      <div class="app-header-logout" @click="logout">
        <img src="@/assets/img/cmb_log_out.png" alt="logout" />
        <span>{{ $t("commonMsg.logout") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import LangSelect from "@/components/langSelect";
import { mapGetters } from "vuex";
export default {
  name: "AppHeader",
  components: {
    LangSelect
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      serverVisible: false,
      locationInfo: { name: "", value: "" },
      serverList: [
        {
          name: "国服（http://admin.onyx-international.cn）",
          value: "http://admin.onyx-international.cn"
        },
        {
          name: "俄服（http://ru-admin.onyx-international.cn）",
          value: "http://ru-admin.onyx-international.cn"
        },
        {
          name: "美服（http://en-admin.onyx-international.cn）",
          value: "http://en-admin.onyx-international.cn"
        },
        {
          name: "欧服（http://eur-admin.onyx-international.cn）",
          value: "http://eur-admin.onyx-international.cn"
        }
      ]
    };
  },
  methods: {
    logout() {
      this.$cookie.remove("token");
      this.$router.push({ name: "login" });
      this.$store.commit("CLEAR_ROUTER");
    },
    navCtrlHandle() {
      this.$store.commit("navCtrl");
    },
    serverHandleCommand(item) {
      if (this.locationInfo.value === item.value) return;
      window.open(item.value);
    }
  },
  mounted() {
    this.locationInfo = this.serverList.find(
      item => item.value === window.location.origin
    );
    if (!this.locationInfo) {
      this.locationInfo = this.serverList[0];
    }
  }
};
</script>

<style lang="scss" scoped>
.app-header {
  background: $globalHeaderBGColor;
  height: 70px;
  line-height: 70px;
  padding: 0 20px 0 30px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  .app-header-left {
    display: flex;
    align-items: center;
    /* font-size: 0; */
    img {
      width: 144px;
      height: 36px;
    }
    .app-header-version {
      height: 50px;
      margin-left: 20px;
          display: table-cell;
       vertical-align: bottom;
    }
  }
  .app-header-right {
    display: flex;
    align-items: center;
    .app-header-user,
    .app-header-logout {
      display: inline-block;
      margin: 0 16px;
      > img {
        width: 20px;
        height: 20px;
        vertical-align: middle;
        margin-right: 8px;
      }
    }
    .column-line-icon {
      width: 4px;
      height: 26px;
      display: inline-block;
      background: url("~@/assets/img/cmb_column_line.png") center no-repeat;
      background-size: 100% 100%;
    }
    .header-langSelect {
      height: 22px;
      width: 22px;
      margin-right: 10px;
    }
    .header-server-select {
      display: flex;
      align-items: center;
      margin-right: 20px;
    }
    .app-header-user {
      display: flex;
      align-items: center;
      img {
        width: 38px;
        height: 38px;
        border-radius: 50%;
      }
    }
    .app-header-logout {
      cursor: pointer;
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>
